import {faRedo, faUndo} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useAppDispatch, useAppSelector} from '../../stores/configureStore'
import {
  isNextImageHistoryItemAvailable,
  isPreviousImageHistoryItemAvailable,
  nextImageHistoryItem,
  previousImageHistoryItem,
} from '../../utils/helpers/editorHistory'
import css from '../../css/historyButton.module.css'
import {useTranslation} from 'react-i18next'

export default function HistoryButtons() {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const editorStore = useAppSelector(store => store.editor)

  return (
    <div
      className="button-container"
      style={{width: 'max-content', marginBottom: 0, alignItems: 'center'}}>
      {isPreviousImageHistoryItemAvailable(editorStore) && (
        <button
          onClick={() => previousImageHistoryItem(dispatch, editorStore)}
          className={css.button}>
          <FontAwesomeIcon icon={faUndo} title={t('Visszavonás')} />
        </button>
      )}
      {isNextImageHistoryItemAvailable(editorStore) && (
        <button
          onClick={() => nextImageHistoryItem(dispatch, editorStore)}
          className={css.button}>
          <FontAwesomeIcon icon={faRedo} title={t('Ismét')} />
        </button>
      )}
    </div>
  )
}
